import {IonBadge, IonCol, IonGrid, IonIcon, IonItem, IonLabel, IonList, IonNote, IonRouterLink, IonRow} from "@ionic/react";
import styles from "./TokenItem.module.scss";
import {star} from "ionicons/icons";
import Ln_TokenPictureSetCoverImg from "../pages/Ln_TokenPictureSetCoverImg";
import styles_1_5 from "../pages/Pg_1_5.module.scss";
import moment from "moment";
import {Fragment, useState} from "react";
import {motion, AnimatePresence} from "framer-motion";


const Icons = {
    ChevronDown: ({className}: { className?: string }) => (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
            <path d="m6 9 6 6 6-6"/>
        </svg>
    ),
    ChevronUp: ({className}: { className?: string }) => (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
            <path d="m18 15-6-6-6 6"/>
        </svg>
    ),
    LayoutGrid: ({className}: { className?: string }) => (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
            <rect width="7" height="7" x="3" y="3" rx="1"/>
            <rect width="7" height="7" x="14" y="3" rx="1"/>
            <rect width="7" height="7" x="14" y="14" rx="1"/>
            <rect width="7" height="7" x="3" y="14" rx="1"/>
        </svg>
    ),
    Briefcase: ({className}: { className?: string }) => (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
            <path d="M16 20V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/>
            <rect width="20" height="14" x="2" y="6" rx="2"/>
        </svg>
    ),
    ImageIcon: ({className}: { className?: string }) => (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
            <rect width="18" height="18" x="3" y="3" rx="2" ry="2"/>
            <circle cx="9" cy="9" r="2"/>
            <path d="m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21"/>
        </svg>
    ),
    Repeat: ({className}: { className?: string }) => (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
            <path d="m17 2 4 4-4 4"/>
            <path d="M3 11V9a4 4 0 0 1 4-4h14"/>
            <path d="m7 22-4-4 4-4"/>
            <path d="M21 13v2a4 4 0 0 1-4 4H3"/>
        </svg>
    ),
    ListOrdered: ({className}: { className?: string }) => (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
            <line x1="10" x2="21" y1="6" y2="6"/>
            <line x1="10" x2="21" y1="12" y2="12"/>
            <line x1="10" x2="21" y1="18" y2="18"/>
            <path d="M4 6h1v4"/>
            <path d="M4 10h2"/>
            <path d="M6 18H4c0-1 2-2 2-3s-1-1.5-2-1"/>
        </svg>
    )
};

export const TokenDetailItem = ({Item_Token, List_庫存 = null as any, fromHome = false}) => {
    let Item_合約: any = Item_Token?._合約;
    if (!Item_合約) {
        return <>(ERROR:Item_合約)</>;
    }
    const [isInventoryExpanded, setIsInventoryExpanded] = useState(false);


    return (
        <IonRow>
            <IonList className={styles_1_5.list}>
                {Item_合約.Name &&
                    <IonItem>
                        <IonGrid>
                            <IonRow>
                                <IonCol><IonLabel>藝術家</IonLabel></IonCol>
                                <IonCol>{Item_合約.Name}</IonCol>
                            </IonRow>
                        </IonGrid>
                    </IonItem>
                }

                {Item_合約.藝術家 &&
                    <IonItem>
                        <IonGrid>
                            <IonRow>
                                <IonCol><IonLabel>藝術家</IonLabel></IonCol>
                                <IonCol>{Item_合約.藝術家}</IonCol>
                            </IonRow>
                        </IonGrid>
                    </IonItem>
                }

                {Item_Token.Series &&
                    <IonItem>
                        <IonGrid>
                            <IonRow>
                                <IonCol><IonLabel>系列</IonLabel></IonCol>
                                <IonCol>{Item_Token.Series}</IonCol>
                            </IonRow>
                        </IonGrid>
                    </IonItem>
                }

                <IonItem>
                    <IonGrid>
                        <IonRow>
                            <IonCol><IonLabel>名稱</IonLabel></IonCol>
                            <IonCol>{Item_Token.名稱}</IonCol>
                        </IonRow>
                    </IonGrid>
                </IonItem>

                <IonItem>
                    <IonGrid>
                        <IonRow>
                            <IonCol><IonLabel>發行數量</IonLabel></IonCol>
                            <IonCol>{Item_Token.數量}</IonCol>
                        </IonRow>
                    </IonGrid>

                </IonItem>

                {/*<IonItem>*/}
                {/*    <IonGrid>*/}
                {/*        <IonRow>*/}
                {/*            <IonCol><IonLabel>稀有度</IonLabel></IonCol>*/}
                {/*            <IonCol>{Item_Token.稀有度}</IonCol>*/}
                {/*        </IonRow>*/}
                {/*    </IonGrid>*/}
                {/*</IonItem>*/}

                <IonItem>
                    <IonGrid>
                        <IonRow>
                            <IonCol><IonLabel>XR型態</IonLabel></IonCol>
                            <IonCol>{Item_Token.ArType}</IonCol>
                        </IonRow>
                    </IonGrid>
                </IonItem>

                {!Item_Token.Is不顯示發行價 &&
                    <IonItem>
                        <IonGrid>
                            <IonRow>
                                <IonCol><IonLabel>發行價</IonLabel></IonCol>
                                <IonCol>${Item_Token.首次發行價格} NTD</IonCol>
                            </IonRow>
                        </IonGrid>
                    </IonItem>
                }

                <IonItem>
                    <IonGrid>
                        <IonRow>
                            <IonCol><IonLabel>發行時間</IonLabel></IonCol>
                            <IonCol>{moment(Item_Token.首次發行時間).format('YYYY/MM/DD hh:mm:ss A')}</IonCol>
                        </IonRow>
                    </IonGrid>

                </IonItem>


                <IonItem>
                    <IonGrid>
                        <IonRow>
                            <IonCol><IonLabel>賦能說明</IonLabel></IonCol>
                            <IonCol>{Item_Token.賦能說明}</IonCol>
                        </IonRow>
                    </IonGrid>

                </IonItem>

                {Item_Token.額外欄位名稱 &&
                    <IonItem>
                        <IonGrid>
                            <IonRow>
                                <IonCol><IonLabel>{Item_Token.額外欄位名稱}</IonLabel></IonCol>
                                <IonCol dangerouslySetInnerHTML={{__html: Item_Token.額外欄位值}}/>
                            </IonRow>
                        </IonGrid>
                    </IonItem>
                }

                <IonItem>
                    <IonGrid>
                        <IonRow>
                            <IonCol><IonLabel>產品碼</IonLabel></IonCol>
                            <IonCol>{Item_Token.SKU}</IonCol>
                        </IonRow>
                    </IonGrid>

                </IonItem>
            </IonList>


            {List_庫存 != null && <Fragment>


                <IonList className={styles_1_5.list}>
                    <IonItem>
                        <IonGrid>
                            <IonRow onClick={() => setIsInventoryExpanded(!isInventoryExpanded)}>
                                {/* Collapsible Inventory Section */}
                                {/*<div className={styles_1_5.inventorySection}>*/}
                                {/*    <button*/}
                                {/*        onClick={() => setIsInventoryExpanded(!isInventoryExpanded)}*/}
                                {/*        className={styles_1_5.collapseButton}*/}
                                {/*        aria-expanded={isInventoryExpanded}*/}
                                {/*    >*/}
                                {/*        <span className={styles_1_5.buttonText}>通路現貨查詢</span>*/}
                                {/*        <div className={styles_1_5.iconWrapper}>*/}
                                {/*            {isInventoryExpanded ? (*/}
                                {/*                <Icons.ChevronUp className="w-4 h-4"/>*/}
                                {/*            ) : (*/}
                                {/*                <Icons.ChevronDown className="w-4 h-4"/>*/}
                                {/*            )}*/}
                                {/*        </div>*/}
                                {/*    </button>*/}
                                {/*</div>*/}

                                <IonCol>
                                    <div
                                        //onClick={() => setIsInventoryExpanded(!isInventoryExpanded)}
                                        //className={styles_1_5.collapseButton}
                                        //aria-expanded={isInventoryExpanded}
                                        className={styles_1_5.wrapperwrapper}
                                    >
                                        <IonLabel>通路現貨查詢</IonLabel>
                                        <div className={styles_1_5.iconWrapper}>
                                            {isInventoryExpanded ? (
                                                <Icons.ChevronUp className="w-4 h-4"/>
                                            ) : (
                                                <Icons.ChevronDown className="w-4 h-4"/>
                                            )}
                                        </div>
                                    </div>
                                </IonCol>
                                <IonCol>

                                </IonCol>
                            </IonRow>
                        </IonGrid>


                    </IonItem>

                    {/*<IonItem>*/}
                    {/*    <IonCol><IonLabel className={styles_1_5.storageTitle}>通路現貨查詢</IonLabel></IonCol>*/}
                    {/*</IonItem>*/}

                    <AnimatePresence initial={false}>
                        {isInventoryExpanded && (
                            <motion.div
                                initial={{height: 0, opacity: 0}}
                                animate={{height: "auto", opacity: 1}}
                                exit={{height: 0, opacity: 0}}
                                transition={{duration: 0.3, ease: "easeInOut"}}
                                className={styles_1_5.inventoryList}
                            >
                                <div className={styles.inventoryItems}>
                                    {List_庫存.map(Item_庫存 => <Fragment>
                                        <IonItem>
                                            <IonGrid>
                                                <IonRow>
                                                    <IonCol className={styles_1_5.intent}><IonLabel>{Item_庫存.DistributionChannel}</IonLabel></IonCol>
                                                    <IonCol>{Item_庫存.Count}</IonCol>
                                                </IonRow>
                                            </IonGrid>
                                        </IonItem>
                                    </Fragment>)}
                                </div>
                            </motion.div>
                        )}
                    </AnimatePresence>

                </IonList>
            </Fragment>}

            {/*<div className={styles.productContainer}>*/}
            {/*    <div className={styles.coverImage}>*/}
            {/*        {Ln_TokenPictureSetCoverImg({*/}
            {/*            圖片組: Item_Token.圖片組,*/}
            {/*            名稱: 'cover',*/}
            {/*        })}*/}
            {/*    </div>*/}
            {/*    <h1 className={`${styles.productTitle} truncate`}>{Item_Token.名稱}</h1>*/}

            {/*    <div className={styles.productInfo}>*/}
            {/*        <div>*/}
            {/*            <IonBadge color="primary">£{Item_Token.首次發行價格.toFixed(2)}</IonBadge>*/}
            {/*        </div>*/}

            {/*        <div className={styles.productRating}>*/}
            {/*            <IonNote>*/}
            {/*                <IonIcon icon={star}/>&nbsp;*/}
            {/*            </IonNote>*/}
            {/*            <IonNote>*/}
            {/*                {5}*/}
            {/*            </IonNote>*/}
            {/*        </div>*/}
            {/*    </div>*/}
            {/*</div>*/}
        </IonRow>
    );
}
